export default "__VITE_ASSET__CWORyuG4__"